<ng-container *ngIf="(form$ | async) as form">
    <form *ngIf="formState$ | async" [formGroup]="form">
        <div mat-dialog-content>
            <mat-accordion>
                <ng-container *ngFor="let section of contentSections$ | async">
                    <app-dynamic-section
                        [section]="section"
                        [form]="form.get(section.id)"
                        [isReadOnly]="(isReadOnly$ | async) === true"
                    >
                    </app-dynamic-section>
                </ng-container>
            </mat-accordion>
        </div>

        <div mat-dialog-actions *ngIf="actionsSection$ | async as actionsSection">
            <app-dynamic-section 
                [section]="actionsSection" 
                [form]="form.get(actionsSection.id)"
                [isDialogActions]="true"
                [isReadOnly]="(isReadOnly$ | async) === true">
            </app-dynamic-section>
        </div>
    </form>
</ng-container>